import React, { Fragment, useEffect } from 'react';
import { connect } from '../../redux/store';
import { actions } from '../../redux/modules/portfolio';
import { I18n } from '@kineticdata/react';
import { PageTitle } from '../shared/PageTitle';
import { ContentManager } from '../shared/content_manager/ContentManager';
import { CONTENT_MANAGER_MODE } from '../shared/content_manager/helpers';
import {
  ErrorMessage,
  LoadingMessage,
  C,
  openModalForm,
  selectServicesKappSlug,
} from '@kineticdata/bundle-common';

const PortfolioComponent = ({
  portfolioId,
  loading,
  error,
  portfolio,
  portfolioName,
  portfolioShortDesc,
  fetchPortfolio,
  kappSlug,
  appLocation,
  isMobile,
}) => {
  useEffect(
    () => {
      if (portfolioId) {
        fetchPortfolio(portfolioId);
      }
    },
    [fetchPortfolio, portfolioId],
  );

  const handleFeedback = () =>
    openModalForm({
      formSlug: C.FORM_SLUG_CATALOG_FEEDBACK,
      kappSlug: kappSlug,
      title: `Provide Portfolio Feedback`,
      values: {
        'Catalog Item Id': portfolioId,
        'Catalog Item Type': 'Portfolio',
        'Catalog Item Name': portfolioName,
        'Catalog Item Form Slug': C.FORM_SLUG_PORTFOLIO,
        'Catalog Submission ID': portfolio.id,
      },
      confirmationMessage: 'Your feedback has been submitted.',
      duration: 5000,
    });

  return (
    <Fragment>
      <div className="page-container">
        <div className="page-panel">
          <PageTitle
            className="page-title-heading--sm"
            parts={[portfolioName, 'Service Catalog']}
            suptitle="PORTFOLIO"
            title={portfolioName}
            breadcrumbs={[
              {
                label: (
                  <span>
                    <span className="fa fa-fw fa-md fa-arrow-left text-muted" />
                    <I18n>Service Catalog</I18n>
                  </span>
                ),
                to: `${appLocation}/servicecatalog`,
              },
            ]}
            actions={[
              portfolio && {
                label: 'Provide Feedback',
                onClick: handleFeedback,
                menu: true,
              },
            ]}
          >
            {portfolioShortDesc && (
              <div className="page-title__meta">{portfolioShortDesc}</div>
            )}
          </PageTitle>

          {error ? (
            <ErrorMessage
              title="The portfolio failed to load."
              message={error.message}
            />
          ) : loading ? (
            <LoadingMessage />
          ) : !!portfolio ? (
            <ContentManager
              submission={portfolio}
              mode={CONTENT_MANAGER_MODE.PUBLIC}
            />
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state, props) => {
  // Get the portfolio from the list to get the name
  const portfolioFromCatalog = state.app.catalog.portfolios.find(
    p => p.values[C.FIELD_PORTFOLIO_ID] === props.portfolioId,
  );
  return {
    loading: state.portfolio.loading,
    error: state.portfolio.error,
    portfolio:
      state.portfolio.id === props.portfolioId ? state.portfolio.data : null,
    portfolioName: portfolioFromCatalog
      ? portfolioFromCatalog.values['Name']
      : '',
    portfolioShortDesc: portfolioFromCatalog
      ? portfolioFromCatalog.values['Short Description']
      : '',
    kappSlug: selectServicesKappSlug(state),
    appLocation: state.app.location,
    layoutSize: state.app.layoutSize,
    isMobile: ['small', 'medium'].includes(state.app.layoutSize),
  };
};

const mapDispatchToProps = { fetchPortfolio: actions.fetchPortfolioRequest };

export const Portfolio = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PortfolioComponent);
